import PointsView from "./PointsView"
import { compose } from "recompose"

PointsView.defaultProps = {
  fontColor: "#ffffff",
  points: 321564,
  pointsSign: "",
}

export default compose(
)(PointsView)